import { NEW, UPDATE, LOADING, FETCH_DATA, CHANGE_FILTERS } from '../actions/commodities';

const commoditiesState = {
    isFetching: false,
    symbols: [],
    filters: {
        period: 'DAY',
        sort: {
            column: 'LONG_NAME',
            direction: 'DESC',
        },
    },
};

export default function commodities(state = commoditiesState, action) {
    switch (action.type) {
    case FETCH_DATA.REQUEST:
        return Object.assign({}, state, {
            isFetching: true,
        });

    case FETCH_DATA.SUCCESS:
        return Object.assign({}, state, {
            isFetching: false,
            symbols: action.payload,
        });

    case FETCH_DATA.FAILURE:
        return Object.assign({}, state, {
            isFetching: false,
        });

    case NEW:
        return Object.assign({}, state, {
            isFetching: false,
            symbols: action.payload,
        });

    case UPDATE:
        return Object.assign({}, state, {
            ...state,
            symbols: state.symbols.map(symbol => {
                if (symbol.key === action.key) {
                    return {
                        key: symbol.key,
                        values: Object.assign({}, symbol.values, action.data),
                    };
                }

                return symbol;
            }),
        });

    case LOADING:
        return Object.assign({}, state, {
            isFetching: true,
        });

    case CHANGE_FILTERS:
        return Object.assign({}, state, {
            ...state,
            filters: Object.assign({}, state.filters, {
                ...action.filters,
            }),
        });

    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/commodities.js
 **/